// extracted by mini-css-extract-plugin
module.exports = {"descriptionWrapper":"InfoTextBlock_descriptionWrapper__2gI5p","descriptionText":"InfoTextBlock_descriptionText__1m1Pl"};